import Cookies from 'js-cookie';
import { COUPON_COOKIE_NAME } from './util';

export default function getCouponCookie() {
  const value = Cookies.get(COUPON_COOKIE_NAME);
  return value ? JSON.parse(value) : undefined;
}
